"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeCurrencyLiveChart = initializeCurrencyLiveChart;
const irt_symbol_1 = require("../../../../js/new/irt-symbol");
const reduce_precision_1 = require("reduce-precision");
const chart_settings_1 = require("../../coins/coins-details/chart-settings");
const irt = new reduce_precision_1.NumberFormatter({ language: 'fa', template: 'irt', precision: 'auto' });
const usd = new reduce_precision_1.NumberFormatter({ language: 'en', template: 'usd', precision: 'auto' });
const percent = new reduce_precision_1.NumberFormatter({ language: 'en', template: 'percent', precision: 'auto' });
const numeric = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));
function initializeCurrencyLiveChart(controller, root, settings) {
    let enabled = settings.get().livePrice;
    let timer;
    let request = null;
    let loaded = document.readyState === 'complete';
    let stopped = false;
    let entryPending = true;
    let idle;
    const info = coin_info;
    const element = document.getElementById(controller.container);
    let lastTimestamp = 0;
    const plotLines = () => {
        const styles = getComputedStyle(document.documentElement);
        const color = styles.getPropertyValue('--arz-color-positive-strong').trim() || '#008c4c';
        return [[info.priceIrt, irt], [info.price, usd]].map(([value, formatter]) => ({
            id: 'lastPrice', value: Number(value), color, width: 1, dashStyle: 'LongDashDot',
            label: { text: formatter.toString(Number(value)), className: 'arz-chart-last-price-label',
                align: 'right', x: -20, useHTML: true,
                style: { color: styles.getPropertyValue('--arz-color-on-state').trim() || '#fff', backgroundColor: color,
                    padding: '3px 5px', borderRadius: '5px', fontSize: '12px', fontWeight: 'bold' } },
        }));
    };
    const syncLines = () => {
        var _a;
        if ((_a = controller.chart) === null || _a === void 0 ? void 0 : _a.renderTo)
            (0, chart_settings_1.syncLivePricePlotLines)(controller.chart, enabled, enabled ? plotLines() : []);
    };
    const schedule = () => {
        window.clearTimeout(timer);
        if (idle !== undefined)
            window.cancelIdleCallback(idle);
        idle = undefined;
        if (stopped || !loaded || document.hidden || !root.dataset.priceApi || request)
            return;
        if (entryPending) {
            // Yield to the initial page load, but bound the wait on a busy main thread.
            if (window.requestIdleCallback)
                idle = window.requestIdleCallback(() => { idle = undefined; return refresh(); }, { timeout: 1000 });
            else
                timer = window.setTimeout(refresh, 0);
            return;
        }
        if (!stopped && loaded && enabled && !document.hidden && root.dataset.priceApi)
            timer = window.setTimeout(refresh, 30000);
    };
    const refresh = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const entry = entryPending;
        if ((!entry && !enabled) || document.hidden || stopped || request)
            return;
        const rect = entry ? null : element === null || element === void 0 ? void 0 : element.getBoundingClientRect();
        if (!entry && (!((_a = controller.chart) === null || _a === void 0 ? void 0 : _a.renderTo) || !rect || rect.bottom < 0 || rect.top > window.innerHeight)) {
            schedule();
            return;
        }
        const pending = new AbortController();
        request = pending;
        const timeout = window.setTimeout(() => pending.abort(), 10000);
        try {
            const url = new URL(root.dataset.priceApi, window.location.origin);
            url.searchParams.set('_', String(Date.now()));
            const options = { credentials: 'omit', cache: 'no-store', signal: pending.signal, priority: 'low' };
            const response = yield fetch(url.toString(), options);
            if (!response.ok)
                return;
            const payload = yield response.json();
            const asset = payload.data;
            if ((!entry && !enabled) || document.hidden || stopped || pending.signal.aborted || payload.status !== 'success' || !asset || asset.slug !== info.slug)
                return;
            if (numeric(asset.usd))
                info.price = Number(asset.usd);
            if (numeric(asset.toman))
                info.priceIrt = Number(asset.toman);
            for (const key of Object.keys(asset)) {
                if (/^price_change_percent_(irt_)?(1h|24h|7d|30d|3m|1y|ytd|all)$/.test(key)) {
                    if (numeric(asset[key]))
                        info[key] = Number(asset[key]);
                }
            }
            const timestamp = Date.parse(asset.last_updated_at);
            if (enabled && ((_b = controller.chart) === null || _b === void 0 ? void 0 : _b.renderTo) && Number.isFinite(timestamp) && timestamp > lastTimestamp) {
                [asset.usd, asset.toman].forEach((value, index) => {
                    var _a;
                    const series = controller.chart.series[index];
                    const last = (_a = series === null || series === void 0 ? void 0 : series.points) === null || _a === void 0 ? void 0 : _a[series.points.length - 1];
                    if (!last || !numeric(value) || timestamp < last.x)
                        return;
                    const previous = series.points[series.points.length - 2];
                    const gap = previous ? Math.max(1, last.x - previous.x) : 60000;
                    if (timestamp - last.x < gap)
                        last.update([timestamp, Number(value)], false);
                    else
                        series.addPoint([timestamp, Number(value)], false, false);
                });
                lastTimestamp = timestamp;
            }
            const primaryUsd = root.dataset.defaultCurrency === 'usd';
            const primary = root.querySelector('.arz-coin-page-data__coin-toman-price > span');
            const secondary = root.querySelector('.coinPrice');
            if (primary && numeric(primaryUsd ? asset.usd : asset.toman))
                primary.innerHTML = (0, irt_symbol_1.html)(primaryUsd ? usd.toString(info.price) : irt.toString(info.priceIrt));
            if (secondary && numeric(primaryUsd ? asset.toman : asset.usd))
                secondary.innerHTML = (0, irt_symbol_1.html)(primaryUsd ? irt.toString(info.priceIrt) : usd.toString(info.price));
            document.querySelectorAll('[data-currency-change]').forEach(cell => {
                const value = asset[`price_change_percent_${primaryUsd ? '' : 'irt_'}${cell.dataset.currencyChange}`];
                if (!numeric(value))
                    return;
                const number = Number(value);
                cell.dataset.rawSwing = String(number);
                cell.classList.remove('arz-positive', 'arz-negative', 'arz-notchange');
                cell.classList.add(number > 0 ? 'arz-positive' : number < 0 ? 'arz-negative' : 'arz-notchange');
                const label = cell.querySelector('.nemayesheSwing');
                if (label)
                    label.textContent = number === 0 ? '0%' : percent.toString(number);
            });
            controller.changePercentInCoinPdp();
            syncLines();
        }
        catch (_error) {
            // Preserve the last valid chart and prices on a failed refresh.
        }
        finally {
            // Retry an interrupted entry on return; ordinary failures retain SSR without a retry loop.
            if (!document.hidden && !stopped)
                entryPending = false;
            window.clearTimeout(timeout);
            request = null;
            schedule();
        }
    });
    document.addEventListener('visibilitychange', () => {
        if (document.hidden)
            request === null || request === void 0 ? void 0 : request.abort();
        schedule();
    });
    window.addEventListener('load', () => { loaded = true; schedule(); }, { once: true });
    window.addEventListener('pagehide', () => { stopped = true; schedule(); request === null || request === void 0 ? void 0 : request.abort(); });
    window.addEventListener('pageshow', (event) => { stopped = false; if (event.persisted)
        entryPending = true; schedule(); });
    // Keep the initial badge in sync with a saved currency before the first refresh.
    controller.changePercentInCoinPdp();
    schedule();
    return {
        setEnabled(value) {
            enabled = value;
            controller.setLivePriceEnabled(value);
            if (!value && !entryPending)
                request === null || request === void 0 ? void 0 : request.abort();
            syncLines();
            schedule();
        },
    };
}
